import React from 'react';
export const ErrorLayout = (props) => {
    const { errorCode, title, children } = props;
    return (React.createElement("div", { className: "fixed inset-0 flex justify-center items-center p-4 " },
        React.createElement("div", { className: "text-center max-w-xs" },
            React.createElement("div", { className: "font-mono text-7xl text-ah-gray-light mb-2 font-bold" }, errorCode),
            React.createElement("h1", { className: "font-bold text-lg my-4" }, title),
            children)));
};
